<template>
  <div
    class="toast-layout"
    :style="{background:false?'none':'rgba(0, 0, 0, 0.3)'}"
    :class="{'toast-active':visible}"
  >
    <div class="toast-con bind-con" :style="{minWidth:'705px'}">
      <div class="t-header ">
        <span>{{lang==='en'?'Add a new device':'添加新设备'}}</span>
        <i class="iconfont icon-cuowu" @click="handleClick"></i>
      </div>
      <div class="binding-con" :style="{height:!bindingSuccess?'395px':'200px'}">
        <div class="binding-body" v-if="!bindingSuccess">
          <div class="b-input">
            <input :class="{notbing:hasBind}" v-model="SN" :placeholder="lang==='en'?'Please input the SN at the bottom of the camera.':'请输入产品底部的SN码'" type="text">
          </div>
          <div class="bind-error">{{hasBind?errorMsg:''}}</div>
          <p v-for="(item,i) in binginfo" :key="i">{{item}}</p>
        </div>
        <div class="binding-success" v-else>
          <img :src="`${$cdn}images/icon/success.png`" alt="">
          <p>{{lang==='en'?'Binding success':'绑定成功'}} </p>
          <p>{{successName}}</p>
        </div>
      </div>

      <div class="bind-btn" >
        <span v-if="!bindingSuccess" @click="binding">{{lang==='en'?'Bind the device':'绑定设备'}}</span>
        <span v-else @click="bindingSuccess=false">{{lang==='en'?'Continue to bind':'继续绑定'}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import toastZH from '@/store/language/cn/toast'
import toastEN from '@/store/language/en/toast'

let binginfo = [
  '1、您可以将自行注册的“用户账号”与设备原生的“相机账号”相绑定。',
  '2、绑定设备后，可进行充值、查看消费记录和解绑等操作。',
  '3、同一台设备只能被一个账号绑定，已经被绑定的设备需要原“用户账号”解绑才可以被再次绑定。',
  '4、设备始终可通过“相机账号”登录，但需要使用APP扫码功能进行。',
  '5 、“相机账号”登录可进行编辑和删除场景等操作，但无法进行充值扩容等操作。'

]
let binginfoEn = [
  '1、You may bind the camera account of the device to your user account.',
  '2、 After binding a device, you may top-up, view the billing records, unbind the device, etc.',
  '3、A device can only be bond to one account. ',
  '4、You can always log into the camera account of the device by scan the QR code on the website via the APP.',
  '5、Login via camera account can edit, and delete the scenes, but not top-up or expand the storage.'
]
export default {
  props: ['visible', 'btype'],
  data () {
    return {
      SN: '',
      hasBind: false,
      errorMsg: '该相机已被绑定',
      bindingSuccess: false,
      successName: '',
      lang: localStorage.getItem('language'),
      toastCode: localStorage.getItem('language') === 'en' ? toastEN : toastZH
    }
  },
  computed: {
    binginfo () {
      return this.lang === 'en' ? binginfoEn : binginfo
    }
  },
  watch: {
    SN () {
      this.hasBind = false
    },
    visible: function (newVal) {
      this.hasBind = false
      this.bindingSuccess = false
      this.lang = localStorage.getItem('language')
      this.toastCode = this.lang === 'en' ? toastEN : toastZH
    }
  },
  methods: {
    handleClick () {
      this.SN = ''
      this.$emit('closePoint')
    },
    async binding () {
      if (!this.SN) {
        this.errorMsg = this.lang === 'en' ? 'Please fill in the SN.' : '序列号不能为空'
        this.hasBind = true
        return false
      }
      let params = {
        snCode: this.SN,
        cameraType: this.btype
      }

      let token = localStorage.getItem('token')
      let result = await this.$http({
        method: 'post',
        data: params,
        headers: {
          token
        },
        url: '/user/camera/add'
      })
      let data = result.data
      if (data.code === 0) {
        this.successName = this.SN
        this.SN = ''
        this.bindingSuccess = true
      } else if (data.code === 4010) {
        this.hasBind = true
        this.errorMsg = this.toastCode['4010']
      } else if (data.code === 6010) {
        this.hasBind = true
        this.errorMsg = this.toastCode['6010']
      } else {
        this.hasBind = true
        this.errorMsg = this.toastCode[data.code]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/toast/binding.vue